import React, { useState } from 'react';
import { Field, reduxForm, reset } from 'redux-form';
import { Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import confirmPasswordBanner from '../assets/images/confirm-password-banner.gif';
import LandingPageHeader from '../Layouts/LandingPageHeader';
import {
  passwordExtraMatches,
  passwordsMustMatch,
  renderField,
  required,
} from '../common/helpers/form-validations';
import SuccessPopUp from '../common/SuccessPopUp';
import { forgotPasswordSubmit } from '../Services/Utils/UserApis';
import { notifySet } from '../Services/Actions/CommonActions';
import { STATUS_MSG, userLogout } from '../Services/config/globals';

function ConfirmPassword(props) {
  const {
    handleSubmit,
    invalid,
    submitting,
    pristine
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const [open, setOpen] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(STATUS_MSG.passwordChanged);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleSuccessPopup = (value) => {
    setOpen(value);
    if (value === false) {
      userLogout();
      navigate('/login');
    }
  };

  const onSubmit = (formData) => {
    let data = {};
    if (user.view.tempPassword === true) {
      data = {
        newPassword: formData.password,
        confirmPassword: formData.confirmPassword,
        tempPassword: false
      };
    } else {
      data = {
        newPassword: formData.password,
        confirmPassword: formData.confirmPassword
      };
    }
    forgotPasswordSubmit(data).then((res) => {
      if (res.status === true) {
        setDisplayMessage(res.message);
        handleClickOpen();
        dispatch(reset('confirmPasswordForm'));
      } else if (res.status === -1) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  // ? show password ?
  const [type, setType] = useState('password');
  const [type1, setType1] = useState('password');
  const [passShow, setPassShow] = useState(true);
  const [passShow1, setPassShow1] = useState(true);

  const handleType = () => {
    if (type === 'text') {
      setType('password');
      setPassShow(true);
    } else if (type === 'password') {
      setType('text');
      setPassShow(false);
    }
  };
  const handleType1 = () => {
    if (type1 === 'text') {
      setType1('password');
      setPassShow1(true);
    } else if (type1 === 'password') {
      setType1('text');
      setPassShow1(false);
    }
  };
  return (
    <div id="fullpage" className="fullpage-wrapper">
      <LandingPageHeader />
      <div className="section">
        <div className="container-fluid banner-top-con full-height-section">
          <div className="container h-100">
            <div className="row h-100">
              <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                <div className="banner-cap-left banner-top banner-top-sm">
                  <img alt="" src={confirmPasswordBanner} />
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 align-self-center">
                <div className="banner-cap-right caption-block title-bg-text">
                  <h1>
                    <span>CREATE</span> <br />
                    <span>NEW</span><br />
                    <span>PASSWORD</span>
                    <br />
                  </h1>
                  <div>
                    <form
                      id="form"
                      form="confirmPasswordForm"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <label htmlFor="password">
                              New Password&nbsp;
                              <span className="validation-icon">*</span>
                            </label>
                            <div className="password-icon-fixd">
                              <Field
                                type={type}
                                component={renderField}
                                name="password"
                                id="password"
                                className="form-control"
                                placeholder="Enter password"
                                validate={[required, passwordExtraMatches]}
                              />
                              <div className="password-icon" onClick={handleType}>
                                {passShow ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <label htmlFor="confirmPassword">
                              Confirm Password&nbsp;
                              <span className="validation-icon">*</span>
                            </label>
                            <div className="password-icon-fixd">
                              <Field
                                type={type1}
                                component={renderField}
                                name="confirmPassword"
                                id="confirmPassword"
                                className="form-control"
                                placeholder="Enter password"
                                validate={[passwordsMustMatch]}
                              />
                              <div className="password-icon" onClick={handleType1}>
                                {passShow1 ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="form-group">
                            <div className="btn-con xs-full-btn mt-1">
                              <span>
                                <Button
                                  type="submit"
                                  className="btn btn-red"
                                  variant="contained"
                                  disabled={invalid || submitting || pristine}
                                >
                                  Change Password
                                </Button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <SuccessPopUp
                    handleClickOpen={handleClickOpen}
                    handleSuccessPopup={handleSuccessPopup}
                    open={open}
                    successMessage={displayMessage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'confirmPasswordForm',
});

export default withForm(ConfirmPassword);
